import React, { useMemo } from 'react';

const getTimeGreeting = (now = new Date()) => {
  const hour = now.getHours();
  if (hour >= 5 && hour <= 11) return 'Good Morning';
  if (hour >= 12 && hour <= 16) return 'Good Afternoon';
  return 'Good Evening';
};

const getFirstName = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw.split(/\s+/)[0] || '';
};

const ChatGreeting = ({
  userName = '',
  suggestedQuestions = [],
  onQuestionClick,
}) => {
  const firstName = getFirstName(userName);
  const greeting = useMemo(() => {
    if (!firstName) return 'Good Evening';
    return `${getTimeGreeting()}, ${firstName}`;
  }, [firstName]);

  return (
    <div className="w-full flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-3xl text-center">
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1a1a1a] dark:text-[#e5e5e5]">
          {greeting}
        </h2>
        <div className="mx-auto mt-3 h-1 w-28 rounded-full bg-[#E87A2A]" />
        <p className="mt-4 text-sm text-slate-600 dark:text-neutral-400">
          What would you like to explore today?
        </p>

        {Array.isArray(suggestedQuestions) && suggestedQuestions.length > 0 && (
          <div className="mt-8 flex flex-wrap items-center justify-center gap-2.5">
            {suggestedQuestions.map((question) => (
              <button
                key={question}
                type="button"
                onClick={() => onQuestionClick?.(question)}
                className="px-4 py-2 rounded-full border text-sm transition-all bg-[rgba(0,0,0,0.02)] dark:bg-[rgba(255,255,255,0.05)] border-slate-200 dark:border-neutral-700 text-[#1a1a1a] dark:text-[#e5e5e5] hover:border-[#E87A2A] hover:text-[#E87A2A]"
              >
                {question}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatGreeting;
